import { createSlice } from '@reduxjs/toolkit';
import type { Dispatch } from 'redux';

export type SidebarState = {
  opened: boolean;
  isBurgerHidden: boolean;
};

const initialState: SidebarState = {
  opened: true,
  isBurgerHidden: false,
};

const sidebarSlice = createSlice({
  name: 'vehicles/sidebar',
  initialState,
  reducers: {
    open: (state) => {
      state.opened = true;
    },
    close: (state) => {
      state.opened = false;
    },
    toggle: (state) => {
      state.opened = !state.opened;
    },
    hideSidebarBurger: (state) => {
      state.isBurgerHidden = true;
    },
    showSidebarBurger: (state) => {
      state.isBurgerHidden = false;
    },
  }
});

export const sidebarActions = sidebarSlice.actions;

export const openSidebar = () => (dispatch: Dispatch) =>
  dispatch(sidebarActions.open());

export const closeSidebar = () => (dispatch: Dispatch) =>
  dispatch(sidebarActions.close());

export const hideSidebarBurger = () => (dispatch: Dispatch) =>
  dispatch(sidebarActions.hideSidebarBurger());

export const showSidebarBurger = () => (dispatch: Dispatch) =>
  dispatch(sidebarActions.showSidebarBurger());

export const toggleSidebar = () => (dispatch: Dispatch) =>
  dispatch(sidebarActions.toggle());

export default sidebarSlice.reducer;
